/* eslint-disable @typescript-eslint/naming-convention */
import { UserClaim } from '@challenger/care/models/user-claim.model';
import { UserToken } from '@challenger/care/models/user-token.model';

export const actions = {
  SET_USER_DETAIL: '[ USER ] set user detail',
  AUTHENTICATE_USER: '[ USER ] authenticating user',
};

export class SetUserDetail {
  static readonly type = actions.SET_USER_DETAIL;
  constructor(
    public payload: {
      claims: UserClaim;
      accessToken: UserToken;
      idToken: UserToken;
    }
  ) {}
}

export class AuthenticatingUser {
  static readonly type = actions.AUTHENTICATE_USER;
  constructor(public isAuthenticating: boolean) {}
}
